import { EvaluationState, NonNullableItemState, ThreadState } from "../../redux/state";
import { ScrollableAreaTabs as CoreScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";
import { Skeleton } from "@material-ui/lab";
import { SpecialistActivityFeed } from "./activityFeed/SpecialistActivityFeed";
import { Messages } from "./messages/Messages";
import { useEffect, useState } from "react";
import { EntityDialog } from "../types";
import { Chip } from "@material-ui/core";
import { EvaluateExperience } from "./evaluation/EvaluateExperience";

export const SpecialistScrollableAreaTabs: React.FC<{
  itemState: NonNullableItemState | null;
  threadState: ThreadState | null;
  evaluationState: EvaluationState;
}> = ({ itemState, threadState, evaluationState }) => {
  const [focussedEntity, setFocussedEntity] = useState<EntityDialog | null>(
    null
  );

  const [unreadThreadCount, setUnreadThreadCount] = useState(0);

  useEffect(() => {
    threadState === null
      ? setUnreadThreadCount(0)
      : setUnreadThreadCount(threadState.messagesUnread);
  }, [threadState, setUnreadThreadCount]);

  const activityTab = (state: NonNullableItemState) => ({
    label: "Activity",
    content: (
      <SpecialistActivityFeed
        specialist={state.item}
        focusedEntity={focussedEntity}
        setFocussedEntity={setFocussedEntity}
      />
    ),
  });

  const messagingTab = (state: NonNullableItemState) => ({
    label:
      unreadThreadCount > 0 ? (
        Object.keys(state.item).length > 0 && threadState?.hasData ?
          (
            <>
              Messaging &nbsp;
              <Chip
                label={threadState!.messagesUnread}
                style={{ background: "Red", color: "whitesmoke" }}
                data-test={"chip-tag-total-unread"}
                size="small"
              />
            </>
          )
          : <></>
      ) : (
        "Messaging"
      ),
    content: (
      <Messages
        sms={state.item}
        focusedEntity={focussedEntity}
        setFocussedEntity={setFocussedEntity}
      />
    ),
    tabTypeId: "messages",
  });

  const evaluationTab = (state: NonNullableItemState) => ({
    label: "Evaluation",
    content: (
      Object.keys(state.item).length > 0 && Object.keys(evaluationState.evaluation).length > 0 ? (
        <EvaluateExperience
          subjects={state.item.subjects}
          evaluations={evaluationState.evaluation}
        />
      ) :
        <></>
    ),
  });

  const tabs = (state: NonNullableItemState) => [
    activityTab(state),
    messagingTab(state),
    evaluationTab(state),
  ];

  return !!itemState ? (
    <CoreScrollableAreaTabs
      twelfths={6}
      dataTest="activity-tabs"
      tabs={tabs(itemState)}
    />
  ) : (
    <>
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
      <br />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="text" height={60} />
      <Skeleton variant="text" height={60} />
      <br />
      <Skeleton variant="rect" height={118} />
    </>
  );
};
